import { render, staticRenderFns } from "./TodoDelete.vue?vue&type=template&id=3fed3180&"
import script from "./TodoDelete.vue?vue&type=script&lang=js&"
export * from "./TodoDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports